import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Router } from '@angular/router';
import { CommonAccountVerifyService } from '../common-myaccount-service/common-account-verify.service';


@Injectable({
  providedIn: 'root'
})
export class AuthGuard  {
  constructor(
    private router: Router,
    private authservice: CommonAccountVerifyService
    ) { }
  canActivate( next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
      const url: string = state.url;
      return  this.verifyLogin(url);
      }

  /** comment
   * verify user login
   */
      verifyLogin(url): boolean {
  const userid = localStorage.getItem('userid');

  if (!userid) {
    this.authservice.redirectUrl = url;
    this.router.navigate(['/signin'], { queryParams: { returnUrl: url } });
    return false;
  }

  return true;
}
    public isLoggedIn(): boolean {
      let status = false;
      if ( this.authservice.checkLoggedIn()) {
          status = true;
      } else {
          status = false;
      }
      return status;
  }
}
